import React from 'react';
import { Link } from 'react-router-dom';
import './Support.css';

function Support() {
  return (
    <div className="support-page">
      <div className="support-container">

        <header className="support-header">
          <h1>Support</h1>
          <p className="last-updated">We're here to help</p>
        </header>

        <section className="support-content">
          <div className="support-section">
            <p>
              Have questions or feedback? Contact us at <a href="mailto:support@redalabs.com">support@redalabs.com</a>
            </p>
            <p>
              We typically respond within 24-48 hours.
            </p>
          </div>
        </section>
      </div>

      <footer className="footer">
        <nav className="footer-nav">
          <Link to="/">Home</Link>
          <span className="separator">|</span>
          <Link to="/terms">Terms of Service</Link>
          <span className="separator">|</span>
          <Link to="/privacy">Privacy Policy</Link>
          <span className="separator">|</span>
          <Link to="/support">Support</Link>
        </nav>
        <p className="copyright">© 2025 Reda Labs, LLC</p>
      </footer>
    </div>
  );
}

export default Support;
